import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Header from "components/Header";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import { getAllRentDispute } from "state/apis";
import EditDispute from "./EditDispute";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DefaultProperty from "components/DefaultProperty";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultProperty } from "state";

const RentDispute = () => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [totalData, setTotalData] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [openAddForm, setOpenAddForm] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [property, setProperty] = React.useState([]);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const defaultProperty = useSelector((state) => state.global.defaultProperty);
    const [units, setFlat] = React.useState([]);
    const dispatch = useDispatch();
    const [role, setRole] = React.useState({});
    const [isSoldProperty, setIsSoldProperty] = React.useState(false);

    React.useEffect(() => {
        fetchData();
        fetchRole();
        if (!defaultProperty) {
            setOpenDefaultProperty(true);
        }
    }, [page, rowsPerPage]);

    const fetchRole = async () => {
        const res = await getDefaultProperty(dispatch);
        setIsSoldProperty(res?.data?.property?.isSold);

        if (res?.data?.role && res?.data?.role?.permission) {
            setRole(JSON.parse(res?.data?.role?.permission));
        }
    };

    const fetchData = async () => {
        try {
            const res = await getAllRentDispute(rowsPerPage, page * rowsPerPage);
            setData(res?.data);
            setTotalData(res?.totalCount);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };
    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleCloseAddForm = () => {
        setOpenAddForm(false);
        setSelectedRow(null);
    };
    const handleSubmitAddReceipt = async () => {
        setOpenAddForm(false);
        setIsLoading(true);
        fetchData();
    };

    const handleEditClick = (row) => {
        setSelectedRow(row);
        setOpenAddForm(true);
    };

    if (isLoading) {
        return (
            <Box sx={{ p: "24px 28px" }}>
                <Header title="Rent Dispute" />
                <Box sx={{ mt: 4, textAlign: "center", color: "#5a6a85" }}>Loading...</Box>
            </Box>
        );
    }

    return (
        <Box sx={{ p: "24px 28px" }}>
            <Header title="Rent Dispute" subtitle="List of rent dispute" />
            <Paper sx={{ width: "100%", overflow: "hidden", mt: 2.5, borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                <TableContainer
                    sx={{ maxHeight: 900 }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Property Name</TableCell>
                                <TableCell>Unit Name</TableCell>
                                <TableCell>Tenant</TableCell>
                                <TableCell>Rent Balance</TableCell>
                                <TableCell>Deposit</TableCell>
                                <TableCell>Closed</TableCell>
                                {role?.rentDispute?.update && !isSoldProperty && (
                                    <TableCell>Actions</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                    <TableCell>{row?.property?.propertyName}</TableCell>
                                    <TableCell>{row?.unit?.unitNumber}</TableCell>
                                    <TableCell>{row?.contract?.tenant?.name}</TableCell>
                                    <TableCell>{row?.rentBalance}</TableCell>
                                    <TableCell>{row?.deposit}</TableCell>
                                    <TableCell>{row?.closed ? "Yes" : "No"}</TableCell>
                                    {role?.rentDispute?.update &&
                                        !row?.closed &&
                                        !isSoldProperty && (
                                            <TableCell>
                                                {role?.rentDispute?.update && (
                                                    <IconButton
                                                        onClick={() => handleEditClick(row)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                        )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <EditDispute
                    open={openAddForm}
                    onClose={handleCloseAddForm}
                    onSubmit={handleSubmitAddReceipt}
                    editData={selectedRow}
                    editMode={!!selectedRow}
                />

                {!defaultProperty && (
                    <DefaultProperty
                        open={openDefaultProperty}
                        onClose={() => handleCloseDefaultProperty}
                    />
                )}
            </Paper>
        </Box>
    );
};

export default RentDispute;
